import React, { useState, useEffect } from 'react';
import ReportTable from './reportTable';


let reportRows = [{
    name: `Shuttle Run Left Trial Time (Laser)`, value: '', key: 'shuttleRunLeftLaserTime'
},
{
    name: `Shuttle Run Left Trial Time (HandHeld)`, value: '', key: 'shuttleRunLeftTrialTime'
},
{
    name: `Shuttle Run Right Trial Time  (laser)`, value: '', key: 'shuttleRunRightLaserTime'
},
{
    name: `Shuttle Run Right Trial Time  (Handheld)`, value: '', key: 'shuttleRunRightTrialTime'
},
{
    name: `Pro Lane Trial Time (Handheld)`, value: '', key: 'proLaneTrialTime'
},
{
    name: `Pro Lane Total Laser Time (laser)`, value: '', key: 'proLaneTotalLaserTime'
},
{
    name: `3/4 Court Sprint Time (Handheld)`, value: '', key: 'threeFourRunTime'
},
{
    name: `3/4 Court Spring Total Laser Time (Laser)`, value: '', key: 'threeFourRunTotalLaserTime'
},
{
    name: `Max Veritcal (in")`, value: '', key: 'maxVerticalInches'
},
{
    name: `Standing Vertical (in")`, value: '', key: 'standingVerticalInches'
},
]
const StrengthAgilityDetails = (props) => {
    const [reportData, setReportData] = useState(reportRows);
    useEffect(() => {

        if (props.data) {
            let rows = [...reportRows];
            rows.forEach((i) => {
                i.value = props.data[i.key] != null ? props.data[i.key] : 0;
            })

            setReportData(rows);
        }

    }, [props.data])

    return (
        <div>
            <ReportTable title={`Strength & Agility`}
                data={props.data}
                reportData={reportData} />
        </div>
    )
}

export default StrengthAgilityDetails;